import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { getProductById } from "@/mocks/products";
import ProductHero from "./components/ProductHero";
import ProductEssence from "./components/ProductEssence";
import ProductRitual from "./components/ProductRitual";
import ProductTransformation from "./components/ProductTransformation";
import ProductDetails from "./components/ProductDetails";
import ProductCTA from "./components/ProductCTA";
import CosmicGrid from "./components/CosmicGrid";

export default function ProductPage() {
  const { id } = useParams<{ id: string }>();
  const product = getProductById(id ?? "");

  const [authChecked, setAuthChecked] = useState(false);
  const [isUnlocked, setIsUnlocked] = useState(false);

  useEffect(() => {
    const unlocked = sessionStorage.getItem("vault_unlocked") === "true";
    setIsUnlocked(unlocked);
    setAuthChecked(true);
  }, []);

  if (!product) {
    return <Navigate to="/" replace />;
  }

  // 認証チェック完了前は何も表示しない（チラ見え防止）
  if (!authChecked) {
    return null;
  }

  // 未認証ならVaultへリダイレクト
  if (!isUnlocked) {
    return <Navigate to="/vault" replace />;
  }

  return (
    <main
      className="bg-[#060508] min-h-screen"
      style={{ fontFamily: "'Cormorant Garamond', serif" }}
    >
      <ProductHero product={product} />
      <ProductEssence product={product} />
      <ProductRitual product={product} />
      {product.id === "mandara" && (
        <CosmicGrid shopifyUrl={product.ctaShopifyUrl} />
      )}
      <ProductTransformation product={product} />
      <ProductDetails product={product} />
      <ProductCTA product={product} />
    </main>
  );
}
